import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Fade from '@mui/material/Fade'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@mui/material'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'
import ImageBg from 'src/assets/Buy_Policy_Images/MotorFormBg.svg'
import thirdPartyType from 'src/assets/Buy_Policy_Images/thirdPartyType.svg'
import comprehensiveType from 'src/assets/Buy_Policy_Images/comprehensiveType.svg'
import ownDamageType from 'src/assets/Buy_Policy_Images/ownDamageType.svg'
import { POLICY_TYPE_BIKE } from 'src/utils/constants/BuyPolicyBike'
import ChoosePolicy from 'src/components/BuyPolicy/insuranceScreens/bike/ChoosePolicy'

const ExploreOptionsModal = (props) => {
  const { open, setOpen } = props
  const classes = useStyles()
  const [, setPolicy] = useState('')
  const [isPolicyExpired, setIsPolicyExpired] = useState(false)

  const handleCloseExplore = () => {
    setOpen(false)
  }

  return (
    <>
      <Modal
        id='Modal'
        aria-labelledby='transition-modal-exploreOptions'
        aria-describedby='transition-modal-description-exploreOptions'
        open={open}
        onClose={handleCloseExplore}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box className={classes.exploreOptionsContainer}>
            <Box className={classes.exploreOptionsSectionMain}>
              <Box className={classes.exploreOptionsCloseIcon}>
                <IconButton onClick={handleCloseExplore} id='IconButton'>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box className={classes.explorePolicyTypeContainer}>
                <Box className={classes.insuranceExploreTypeContainer}>
                  <Box className={classes.insuranceExploreTypeTitle}>
                    Choose the policy type
                  </Box>
                  <Box className={classes.insuranceExploreTypeRow}>
                    <Box className={classes.thirdPartyTypeExplore}>
                      <Box className={classes.thirdPartyTitleExplore}>
                        Third-Party
                      </Box>
                      <Box className={classes.thirdPartySubheadingTextExplore}>
                        Covers damage to <b>others only</b>
                      </Box>
                      <Box>
                        <img
                          src={thirdPartyType}
                          alt='thirdPartyLogo'
                          className={classes.insuranceExploreImages}
                        />
                      </Box>
                      <Box className={classes.insuranceExploreTypeText}>
                        <ChoosePolicy
                          policyTypeChoosen={POLICY_TYPE_BIKE?.THIRD_PARTY}
                          isPolicyExpired={isPolicyExpired}
                          setIsPolicyExpired={setIsPolicyExpired}
                          setPolicy={setPolicy}
                        />
                      </Box>
                    </Box>
                    <Box className={classes.comprehensiveTypeExplore}>
                      <Box className={classes.comprehensiveTitleExplore}>
                        Comprehensive
                      </Box>
                      <Box
                        className={classes.comprehensiveSubheadingTextExplore}
                      >
                        Covers <b>both</b> you and others
                      </Box>
                      <Box>
                        <img
                          src={comprehensiveType}
                          alt='comprehensiveLogo'
                          className={classes.insuranceExploreImages}
                        />
                      </Box>
                      <Box className={classes.insuranceTypeTextExplore}>
                        <ChoosePolicy
                          policyTypeChoosen={POLICY_TYPE_BIKE?.COMPREHENSIVE}
                          isPolicyExpired={isPolicyExpired}
                          setIsPolicyExpired={setIsPolicyExpired}
                          setPolicy={setPolicy}
                        />
                      </Box>
                    </Box>
                    <Box className={classes.ownDamageTypeExplore}>
                      <Box className={classes.ownDamageTitleExplore}>
                        Own Damage
                      </Box>
                      <Box className={classes.ownDamageSubheadingTextExplore}>
                        Should be chosen
                        <br /> <b>if Third-Party is active</b>
                      </Box>
                      <Box>
                        <img
                          src={ownDamageType}
                          alt='ownDamageLogo'
                          className={classes.insuranceExploreImages}
                        />
                      </Box>
                      <Box className={classes.insuranceExploreTypeText}>
                        <ChoosePolicy
                          policyTypeChoosen={POLICY_TYPE_BIKE?.OWNDAMAGE}
                          isPolicyExpired={isPolicyExpired}
                          setIsPolicyExpired={setIsPolicyExpired}
                          setPolicy={setPolicy}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

export default ExploreOptionsModal

const useStyles = makeStyles({
  exploreOptionsContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    width: '65vw',
  },
  exploreOptionsSectionMain: {
    display: 'flex',
    backgroundImage: `url(${ImageBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
  },
  exploreOptionsCloseIcon: {
    position: 'absolute',
    textAlign: 'right',
    right: '0',
    top: '0',
  },
  explorePolicyTypeContainer: {},
  policyExpiryContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  policyExpirySection: {
    paddingTop: 20,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 5,
    borderRadius: 10,
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px 0px #00000066',
  },
  formRadioText: {
    marginTop: '-15px',
  },
  radioBtnSelected: {
    '& .MuiSvgIcon-root': {},
  },
  RadioBtnText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '19.55px',
    letterSpacing: '0em',
    marginLeft: '-7px',
  },
  insuranceExploreTypeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
    padding: 18,
    backgroundColor: '#FFFFFF',
    fontFamily: 'Roboto',
  },
  insuranceExploreTypeTitle: {
    fontFamily: 'Roboto',
    fontWeight: '300px',
    fontSize: '24px',
    lineHeight: '34.13px',
  },
  insuranceExploreTypeRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    justifyContent: 'space-between',
    '@media (max-width:770px)': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 10,
      gap: 20,
    },
  },
  thirdPartyTypeExplore: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    paddingTop: '10px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #EF669B -80.32%, rgba(255, 255, 255, 0) 60.09%)',
  },
  comprehensiveTypeExplore: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    paddingTop: '10px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #4DC3E3 -80.32%, rgba(255, 255, 255, 0) 60.09%)',
  },
  ownDamageTypeExplore: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    paddingTop: '10px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #9271BE -80.32%, rgba(255, 255, 255, 0) 60.09%)',
  },
  thirdPartyTitleExplore: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#E25B8F',
  },
  comprehensiveTitleExplore: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#3092AD',
  },
  ownDamageTitleExplore: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#8561B5',
  },
  thirdPartySubheadingTextExplore: {
    textAlign: 'center',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#EF669B',
    padding: '20px',
    margin: '10px',
    color: '#972853',
    fontSize: '14px',
    width: '200px',
    maxHeight: '60px',
  },
  comprehensiveSubheadingTextExplore: {
    textAlign: 'center',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#4DC3E3',
    padding: '20px',
    margin: '10px',
    color: '#23687B',
    fontSize: '14px',
    width: '200px',
    maxHeight: '60px',
  },
  ownDamageSubheadingTextExplore: {
    textAlign: 'center',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#9271BE',
    padding: '13px 20px',
    margin: '10px',
    color: '#734AAA',
    fontSize: '14px',
    width: '200px',
    maxHeight: '60px',
  },
  insuranceExploreTypeText: {
    fontSize: '16px',
    lineHeight: '21px',
    padding: '10px 0px',
  },
  insuranceExploreImages: {
    padding: '10px',
  },
})
